/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';
    
    /**
     * Factory callback type
     */
    declare type MdFabSpeedDialDirectiveFactoryCb = () => MdFabSpeedDialDirective;
    
    /**
     * Custom scope
     */
    export interface IMdFabSpeedDialDirectiveScopeDef {
    }
    
    /**
     * Custom scope
     */
    export interface IMdFabSpeedDialDirectiveScope extends ng.IScope {
    }
    
    /**
     * MdFabSpeedDialDirective
     */
    export class MdFabSpeedDialDirective implements ng.IDirective {
        public static $name: string = "mdFabSpeedDial";
        
        public link: (scope: IMdFabSpeedDialDirectiveScope, element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'A';
        public transclude: boolean = false;
        public scope: IMdFabSpeedDialDirectiveScopeDef = {
        };

        /**
         * Factory for the directive
         */
        public static Factory(): MdFabSpeedDialDirectiveFactoryCb {
            let directive: MdFabSpeedDialDirectiveFactoryCb = () => {
                return new MdFabSpeedDialDirective();
            };
            return directive;
        }

        /**
         * Constructor
         */
        constructor() {
            MdFabSpeedDialDirective.prototype.link = (scope: IMdFabSpeedDialDirectiveScope, element: JQuery, attrs: ng.IAttributes) => {
                $(element)
                    .append('<i class="material-icons md-fab-action-close" style="display:none">&#xE5CD;</i>')
                    .on('click', function(e: Event): void {
                        e.preventDefault();

                        let $this: JQuery = $(this);
                        let $thisWrapper: JQuery = $this.closest('.md-fab-wrapper');

                        if (!$thisWrapper.hasClass('md-fab-active')) {
                            $thisWrapper.addClass('md-fab-active');
                        } else {
                            $thisWrapper.removeClass('md-fab-active');
                        }

                        $this.velocity({
                            scale: 0,
                        }, {
                            duration: 250,
                            easing: 'swing',
                            complete: function(): void {
                                $this.children().toggle();
                                $this.velocity({
                                    scale: 1,
                                }, {
                                    duration: 250,
                                    easing: 'swing',
                                });
                            },
                        });
                    })
                    .closest('.md-fab-wrapper').find('.md-fab-small')
                    .on('click', function(): void {
                        $(element).trigger('click');
                    });
            };
        }
    }
}
